import * as yup from "yup";

export default yup.string().matches(/^[A-Za-z]+$/i, "Invalid Input");
